import React, { FC, memo } from 'react'
import Button from 'components/Common/Button'
import { getCurrentRoute } from 'utils/helper'
import history from 'utils/history'

export interface IToolBreadCrumbProps {
  title: string
}

const ToolBreadCrumb: FC<IToolBreadCrumbProps> = ({ title }) => {
  let path = getCurrentRoute()
  const redirectPath = path.slice(0, path.lastIndexOf('/'))

  return (
    <div className="xs:px-5 sm:px-0 flex">
      <Button label="Tools" variant="text" onClick={() => history.push(redirectPath)} />
      <span className="text-primary whitespace-break-spaces"> / </span>
      <span className="text-silver-lighter1x font-[650]">{title}</span>
    </div>
  )
}

export default memo(ToolBreadCrumb)
